// extracted by mini-css-extract-plugin
export default {"dialog":"BeforeRenewModal__dialog--2gbDi","title":"BeforeRenewModal__title--2UmuA","content":"BeforeRenewModal__content--14Nyy"};